import React from "react";
import { XCircle } from "lucide-react";

export function ErrorMessage({ message }) {
  if (!message) return null;
  
  return (
    <div className="mt-4 p-4 rounded-lg bg-red-50 border-2 border-red-200 space-y-3">
      <div className="flex items-start gap-3">
        <XCircle className="w-5 h-5 mt-0.5 text-red-500 flex-shrink-0" />
        <div className="text-left">
          <h3 className="font-semibold text-red-700">Upload Error</h3>
          <p className="text-red-600 text-sm mt-1">{message}</p>
          <ul className="list-disc pl-5 mt-2 text-red-600/90 text-sm space-y-1">
            <li>Allowed formats: CSV, XLSX, XLS</li>
            <li>Max file size: 200 MB</li>
            <li>Required columns: Address information</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ErrorMessage;
